ui-bank-search-map-overlay {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  position: relative;

  .sr-only {
    @include sr-only;
  }

  .map-overlay {
    ui-bank-search-autocomplete {
      margin: 0 $sd-spacing-3;
    }

    &--mobile {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      pointer-events: none;
      height: var(--map-height-mobile);

      @include breakpoint($desktop) {
        // CAUTION
        // (1) display:none would cause swiper failing to initialize correctly when starting
        // in desktop view and then shrinking the viewport to trigger mobile view. The first slide
        // item would have full width and refuse to be swipable.
        // (2) display:none would cause 'TypeError swiper.visibleSlides undefined' when starting
        // in desktop view and loading more banks.
        visibility: hidden;
        // (!) also requires suppressing scroll bars on .bank-search
      }
    }

    &--desktop {
      display: none;
      pointer-events: auto;

      @include breakpoint($desktop) {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: $sd-spacing-5 0 0;
      }
    }

    &__filter,
    &__list {
      background-color: $sd-backgroundColor-white;
      pointer-events: auto;
    }

    &__filter {
      sd-scrollable {
        margin: $sd-spacing-5 0;
        padding: 0 $sd-spacing-2;

        sd-tag {
          margin-right: $sd-spacing-2;
        }
      }
    }

    &__list {
      display: flex;
      flex-direction: column;
      height: 1%;
      flex: 1;
    }

    &__alert {
      padding: 0 $sd-spacing-2\.5;
    }
  }

  @include breakpoint($desktop) {
    max-width: 335px;
    margin: $sd-spacing-5;
    padding: 0;
    background-color: $sd-backgroundColor-white;
  }

  ui-bank-search-autosuggest {
    margin-left: $sd-spacing-4;
    margin-right: $sd-spacing-4;
  }

  .mobile-toggle {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 300px;
    right: $sd-spacing-2\.5;
    border-radius: 50%;
    padding: $sd-spacing-2\.5;
    pointer-events: auto;
    z-index: 10;

    sd-radio-button::part(button) {
      background-color: $sd-backgroundColor-white;
    }

    sd-radio-button::part(button--checked) {
      border-color: $sd-borderColor-accent-DEFAULT;
      background-color: $sd-backgroundColor-accent-DEFAULT;
    }

    &--condensed {
      bottom: 125px;
    }

    &--list {
      bottom: 0;
    }

    @include breakpoint($desktop) {
      display: none;
    }
  }
}
